import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MeteorologyAgroWBCultureState {
  selectedChartVariables: number[];
  periodStartCP: string | undefined;
  periodEndCP: string | undefined;
  selectedCultureCP: number | undefined;
  selectedSoilCP: number | undefined;
  selectedEmergencyDateCP: string | undefined;
  selectedGroupCP: number | undefined;
  selectedLocationCP: number | undefined;
  triggerRequest: (() => void) | undefined;
}

const initialState: MeteorologyAgroWBCultureState = {
  selectedChartVariables: [],
  periodStartCP: undefined,
  periodEndCP: undefined,
  selectedCultureCP: undefined,
  selectedSoilCP: undefined,
  selectedEmergencyDateCP: undefined,
  selectedGroupCP: undefined,
  selectedLocationCP: undefined,
  triggerRequest: undefined,
};

export const meteorologyAgroWBCultureSlice = createSlice({
  name: 'meteorologyAgroWBCulture',
  initialState,
  reducers: {
    resetCP: (state) => {
      Object.assign(state, {
        ...state,
        // filtros
        periodStartCP: undefined,
        periodEndCP: undefined,
        selectedCultureCP: undefined,
        selectedSoilCP: undefined,
        selectedEmergencyDateCP: '',
        selectedGroupCP: undefined,
        selectedLocationCP: undefined,

        // gráficos / consulta
        selectedChartVariables: [],
        triggerRequest: undefined,
      });
    },
    setChart: (state, action: PayloadAction<number[]>) => {
      state.selectedChartVariables = action.payload;
    },
    setPeriodStartCP: (state, action: PayloadAction<string | undefined>) => {
      state.periodStartCP = action.payload;
    },
    setPeriodEndCP: (state, action: PayloadAction<string | undefined>) => {
      state.periodEndCP = action.payload;
    },
    setCultureCP: (state, action: PayloadAction<number | undefined>) => {
      state.selectedCultureCP = action.payload;
    },
    setSoilCP: (state, action: PayloadAction<number | undefined>) => {
      state.selectedSoilCP = action.payload;
    },
    setEmergencyDateCP: (state, action: PayloadAction<string | undefined>) => {
      state.selectedEmergencyDateCP = action.payload;
    },
    setGroupCP: (state, action: PayloadAction<number | undefined>) => {
      state.selectedGroupCP = action.payload;
    },
    setLocationCP: (state, action: PayloadAction<number | undefined>) => {
      state.selectedLocationCP = action.payload;
    },
    setTriggerRequest: (state, action: PayloadAction<(() => void) | undefined>) => {
      state.triggerRequest = action.payload;
    },
  },
});

export const selectMeteorologyAgroWBCultureSelectedChartVariables = (state: any) => (
  state.meteorologyAgroWBCulture.selectedChartVariables
);

export const selectMeteorologyAgroWBCulturePeriodStartCP = (state: any) => (
  state.meteorologyAgroWBCulture.periodStartCP
);

export const selectMeteorologyAgroWBCulturePeriodEndCP = (state: any) => (
  state.meteorologyAgroWBCulture.periodEndCP
);

export const selectMeteorologyAgroWBCultureSelectedCultureCP = (state: any) => (
  state.meteorologyAgroWBCulture.selectedCultureCP
);

export const selectMeteorologyAgroWBCultureSelectedSoilCP = (state: any) => (
  state.meteorologyAgroWBCulture.selectedSoilCP
);

export const selectMeteorologyAgroWBCultureSelectedEmergencyDateCP = (state: any) => (
  state.meteorologyAgroWBCulture.selectedEmergencyDateCP
);

export const selectMeteorologyAgroWBCultureSelectedGroupCP = (state: any) => (
  state.meteorologyAgroWBCulture.selectedGroupCP
);

export const selectMeteorologyAgroWBCultureSelectedLocationCP = (state: any) => (
  state.meteorologyAgroWBCulture.selectedLocationCP
);

export const selectMeteorologyAgroWBCultureTriggerRequest = (state: any) => (
  state.meteorologyAgroWBCulture.triggerRequest
);

export const {
  resetCP,
  setChart,
  setPeriodStartCP,
  setPeriodEndCP,
  setCultureCP,
  setSoilCP,
  setEmergencyDateCP,
  setGroupCP,
  setLocationCP,
  setTriggerRequest,
} = meteorologyAgroWBCultureSlice.actions;

export default meteorologyAgroWBCultureSlice.reducer;
